import React from "react";
import PropTypes from "prop-types";
import { formatDateWithTime } from "core/util/dateUtilities";

const Row = ({ broadcast }) => {
    const {
        sentDate,
        subject,
        content,
        recipients
    } = broadcast;
    return (
        <tr>
            <td>{formatDateWithTime(sentDate)}</td>
            <td>{subject}</td>
            <td>{content.replace(/<br>/g, "\n")}</td>
            <td>{recipients}</td>
        </tr>
    );
};

Row.propTypes = {
    broadcast: PropTypes.any.isRequired
};

export default Row;
